import { actionCreator } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';

const DOMAIN = '[loadedState/excludeComponent]';

export type ExcludeComponentFromViewpointPayload = {
  componentId: ArdoqId;
  /** For the toast, so the user is told what left rather than that something did. */
  componentName: string | null;
};

export const excludeComponentFromViewpoint =
  actionCreator<ExcludeComponentFromViewpointPayload>(
    `${DOMAIN} exclude component from viewpoint`
  );

export const showAllExcludedComponents = actionCreator(
  `${DOMAIN} show all excluded components`
);

/**
 * Reverts one exclusion, which is what Undo on the confirmation toast means.
 *
 * Separate from {@link showAllExcludedComponents} because that one is the toolbar's bulk control:
 * reverting everything from a toast would discard exclusions made earlier in the session and any
 * the viewpoint was saved with.
 */
export const showExcludedComponentAgain = actionCreator<{
  componentId: ArdoqId;
  /** For the toast, so it names what came back rather than implying all of them did. */
  componentName: string | null;
  /**
   * The datasets the exclusion was written to, by `stateToHash`.
   *
   * Carried rather than recomputed because the two ends do not select the same datasets: excluding
   * writes to the traversals drawing the component, and a traversal that already excludes it is not
   * one of them. Recomputing at Undo time picks up exactly those, so it would revert an exclusion
   * this action never made.
   */
  targetHashes: string[];
}>(`${DOMAIN} show excluded component again`);
